import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";

import { Box, Button, Stack, Typography } from "@mui/material";

import { centeredBoxSx } from "../styles/centeredBoxSx";
import { getUserDisplayName } from "./userDisplayName";

/**
 * Full-viewport page for a user who is authenticated but holds none of the roles the app requires
 * (e.g. an account provisioned by federation without rights, or a token from the wrong realm's
 * user population). Shows who is signed in and offers an explicit sign-out — deliberately no
 * automatic sign-out, so the user can read the message and switch accounts on their own terms.
 */
export const NoPermissionPage = () => {
  const auth = useAuth();
  const { t } = useTranslation();

  const displayName = getUserDisplayName(auth.user);
  const userName = auth.user?.profile.preferred_username ?? "";

  return (
    <Box sx={centeredBoxSx}>
      <Typography variant="h5" component="h1">
        {t("auth.noPermissionTitle")}
      </Typography>
      <Typography color="text.secondary">{t("auth.noPermissionMessage")}</Typography>
      <Stack direction="row" spacing={1} alignItems="baseline">
        <Typography variant="body2" color="text.secondary">
          {t("auth.signedInAs")}
        </Typography>
        <Typography variant="body2" fontWeight="bold">
          {displayName}
        </Typography>
        {userName && userName !== displayName && (
          <Typography variant="body2" color="text.secondary">
            ({userName})
          </Typography>
        )}
      </Stack>
      <Button variant="contained" onClick={() => void auth.signoutRedirect()}>
        {t("auth.logout")}
      </Button>
    </Box>
  );
};
